import {IssueOpenedIcon, IssueClosedIcon} from '@primer/octicons-react'
import conversationStyles from './ConversationList.module.css'
import styles from './IssueSection.module.css'
import type {IssueDataPoint} from '../types'
import {pluralize, createRelativeTimeProps} from '../helpers/infographic-helpers'
import {Link, RelativeTime} from '@primer/react'

interface IssueSectionProps {
  type: 'opened' | 'closed'
  count?: number
  peopleCount?: number
  issues?: IssueDataPoint[]
}

const DEFAULT_ISSUES: IssueSectionProps['issues'] = []

export function IssueSection({type, count = 0, peopleCount = 0, issues = DEFAULT_ISSUES}: IssueSectionProps) {
  const Icon = type === 'opened' ? IssueOpenedIcon : IssueClosedIcon
  const iconClass = type === 'opened' ? 'color-fg-success' : 'color-fg-done'
  const title = type === 'opened' ? `${pluralize(count, 'issue')} opened` : `${pluralize(count, 'issue')} closed`
  const sectionId = type === 'opened' ? 'opened-issues' : 'closed-issues'

  return issues && issues.length > 0 ? (
    <section className={styles.section}>
      <div>
        <h3 className={conversationStyles.conversationListHeading} id={sectionId}>
          <span className={conversationStyles.inner}>
            <Icon className={iconClass} /> <strong className="color-fg-default">{count}</strong> {title} by{' '}
            <strong className="color-fg-default">{peopleCount}</strong> {pluralize(peopleCount, 'person', 'people')}
          </span>
        </h3>
      </div>

      <ul className="list-style-none my-4">
        {issues && issues.length > 0 ? (
          issues.map(issue => (
            <li key={issue.number} className="clearfix">
              <Icon className={`${iconClass} float-left mt-1`} />
              <div className="overflow-hidden pl-2">
                <Link href={issue.path} className="h4 Link--primary mb-1 markdown-title">
                  {issue.title}
                </Link>
                <p className="color-fg-muted text-small">
                  <span className="num">#{issue.number}</span> {type}{' '}
                  <RelativeTime {...createRelativeTimeProps(issue.closedAt ?? issue.createdAt)} />
                </p>
              </div>
            </li>
          ))
        ) : (
          <li className="clearfix">
            <Icon className={`${iconClass} float-left mt-1`} />
            <div className="overflow-hidden pl-2">
              <a href="filler" className="h4 Link--primary mb-1 markdown-title">
                [Example Issue]
              </a>
              <p className="color-fg-muted text-small">
                <span className="num">#0000</span> {type} yesterday
              </p>
            </div>
          </li>
        )}
      </ul>
    </section>
  ) : null
}

try{ IssueSection.displayName ||= 'IssueSection' } catch {}